export default "__VITE_PUBLIC_ASSET__1cacc3ec__"